// @ts-nocheck

import React, { useState, useCallback, useEffect } from 'react';

import type { UserClearLastSessionSettledBetsAction } from '../../actions/user';
import { Target } from '../../client';
import { ModalFormat, ModalContentSpacing } from '../../constants/ui/modal';
import { Modal as ModalTheme } from '../../styled-components/dark/modal';
import Modal from '../Modal';
import ScaleTransitionGroup from '../ScaleTransitionGroup';
import WinModalContentContainer from '../WinModalContent/WinModalContentContainer';

type WinModalProps = {
  betslipReferencesToFetch: Array<string>;
  askBetslipInfo: (betslipReference: string) => void;
  clearLastSessionSettledBets: UserClearLastSessionSettledBetsAction;
  shouldOpen: boolean;
  shouldClearLastSessionsSettledBets: boolean;
  betslipIds: Array<string>;
  hasNavBarSpacing: boolean;
};

const WinModal = ({
  askBetslipInfo,
  clearLastSessionSettledBets,
  betslipReferencesToFetch,
  shouldOpen,
  shouldClearLastSessionsSettledBets,
  betslipIds,
  hasNavBarSpacing,
}: WinModalProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const onClose = useCallback(() => {
    setIsOpen(false);
    clearLastSessionSettledBets();
  }, [clearLastSessionSettledBets]);

  useEffect(() => {
    if (shouldClearLastSessionsSettledBets) {
      clearLastSessionSettledBets();
    }
  }, [clearLastSessionSettledBets, shouldClearLastSessionsSettledBets]);

  useEffect(() => {
    if (betslipReferencesToFetch.length !== 0) {
      betslipReferencesToFetch.forEach((betslipReference) => askBetslipInfo(betslipReference));
    }
  }, [askBetslipInfo, betslipReferencesToFetch]);

  useEffect(() => {
    if (shouldOpen && betslipIds.length > 0) {
      setIsOpen(true);
    }
  }, [betslipIds.length, shouldOpen]);

  return (
    <ScaleTransitionGroup>
      {isOpen ? (
        <Modal
          backgroundColor={ModalTheme.backgroundColor.default}
          contentSpacing={ModalContentSpacing.NONE}
          closeOnEsc
          format={Target.__MOBILE__ ? ModalFormat.FULLSCREEN : ModalFormat.DESKTOP}
          fullHeight
          hasOverlay={!Target.__MOBILE__}
          hasNavBarSpacing={hasNavBarSpacing}
          onClose={onClose}
          useViewportSize
          forbidBackgroundScrolling
        >
          <WinModalContentContainer onClose={onClose} betslipIds={betslipIds} />
        </Modal>
      ) : null}
    </ScaleTransitionGroup>
  );
};

export default WinModal;
